import { IconButton, InputAdornment, SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

interface Props {
    onClick?: () => void;
    Icon?: OverridableComponent<SvgIconTypeMap> & { muiName: string };
}

export const IconFieldText = ({ onClick, Icon }: Props) => {
    return (
        <InputAdornment position="end">
            {!!Icon && (
                <IconButton
                    onClick={onClick}
                    aria-label="toggle password"
                    edge="end"
                >
                    <Icon sx={{ color: 'primary.main' }} />
                </IconButton>
            )}
        </InputAdornment>
    );
};
